<h1 mat-dialog-title>Info</h1>
<mat-dialog-content>Sie haben zu oft versucht sich mit ungültigen Daten anzumelden. <br/> Bitte melden sie sich bei der VG Bild-Kunst.</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button
            color="primary"
            mat-dialog-close>OK</button>
</mat-dialog-actions>